import { Table, Container, Row } from "reactstrap";


const OrgSearchRow = ({ data, type, action }) => {


    return (
        <tr>
            <th>{data.accountId}</th>
            <td>{data.name}</td>
            <td>{data.organizationName}</td>
            <td>{data.organizationId}</td>
            <td>{data.address}</td>
            <td>{data.address2}</td>
            <td>{data.city}</td>
            <td>{data.state}</td>
            <td>{data.zip}</td>
        </tr>
    )
};

const OrgSearchHeader = ({ type }) => {

    return (
        <tr>
            <th>Id</th>
            <th>Name</th>
            <th>Location</th>
            <th>Location Account</th>
            <th>Address</th>
            <th>Address 2</th>
            <th>City</th>
            <th>State</th>
            <th>Zip</th>
        </tr>
    )
};

const OrgSearchEmptyHeader = () => {
    return (
        <tr>
            <th></th>
        </tr>
    )
};

const OrgSearchEmptyResultsRow = () => {
    return (
        <tr>
            <td><h4 className="text-center">No Results Found</h4></td>
        </tr>
    )
};

const OrgSearchTableUser = ({ data, type }) => {
    return (
        <Container fluid>
            <Row className="table-responsive">
                <Table className="table-sm table-striped">
                    <thead className="search-thead">
                        {(data === null || data.length === 0) && <OrgSearchEmptyHeader />}
                        {data !== null && data.length > 0 && <OrgSearchHeader type={type} />}
                    </thead>
                    <tbody className="search-tbody">
                        {(data === null || data.length === 0) && <OrgSearchEmptyResultsRow />}
                        {data.map((row) => {
                            return row.organizations.map((subRow, index) => {
                                var composedRow = {
                                    ...row,
                                    organizationId: subRow.organizationId,
                                    organizationName: subRow.organizationName
                                }
                            
                                return <OrgSearchRow key={`${row.accountId}-${subRow.organizationId}`} data={composedRow} type={type} />


                            })
                        })}
                    </tbody>
                </Table>
            </Row>
        </Container> 
    )
};

export default OrgSearchTableUser;